// Module
var code = "<md-content layout-align=\"center center\" layout layout-fill flex> <div layout-margin> <h1 class=\"mr3\">Organization switch in progress</h1> <p class=\"grey-500\">Please hold on while the data is being loaded ...</p> </div> </md-content> ";
// Exports
module.exports = code;